const dataIp = () => fetch('https://ipapi.co/json/')
  .then((response) => response.json())
  .catch((error) => {
    throw error;
  });

export default dataIp;
